function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("rect", {
  width: 36,
  height: 36,
  rx: 5,
  fill: "#FF9800"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M17.99 8C12.47 8 8 12.48 8 18s4.47 10 9.99 10C23.52 28 28 23.52 28 18S23.52 8 17.99 8zm-3.49 6c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5-1.5-.67-1.5-1.5.67-1.5 1.5-1.5zM18 24c-2.28 0-4.22-1.66-5-4h10c-.78 2.34-2.72 4-5 4zm3.5-7c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z",
  fill: "#FF9800"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M17.99 8C12.47 8 8 12.48 8 18s4.47 10 9.99 10C23.52 28 28 23.52 28 18S23.52 8 17.99 8zm-3.49 6c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5-1.5-.67-1.5-1.5.67-1.5 1.5-1.5zM18 24c-2.28 0-4.22-1.66-5-4h10c-.78 2.34-2.72 4-5 4zm3.5-7c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z",
  fill: "#fff",
  fillOpacity: 0.9
});

function SvgAppreciation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none"
  }, props), _ref, _ref2, _ref3);
}

export default SvgAppreciation;